import script from "./noticePopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./noticePopup.vue?vue&type=script&lang=ts&setup=true"

import "./noticePopup.vue?vue&type=style&index=0&id=5e5458df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5458df"]])

export default __exports__